export const CaretUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.8193 17.2501H6.81925C6.68082 17.2493 6.54525 17.2106 6.42718 17.1384C6.3091 17.0661 6.213 16.963 6.14925 16.8401C6.08592 16.715 6.05891 16.5747 6.07129 16.4351C6.08366 16.2955 6.13492 16.1621 6.21925 16.0501L12.2193 8.0501C12.2914 7.96038 12.3828 7.88799 12.4866 7.83825C12.5904 7.78851 12.7041 7.7627 12.8193 7.7627C12.9344 7.7627 13.0481 7.78851 13.1519 7.83825C13.2557 7.88799 13.3471 7.96038 13.4193 8.0501L19.4193 16.0501C19.5036 16.1621 19.5548 16.2955 19.5672 16.4351C19.5796 16.5747 19.5526 16.715 19.4893 16.8401C19.4255 16.963 19.3294 17.0661 19.2113 17.1384C19.0932 17.2106 18.9577 17.2493 18.8193 17.2501ZM8.31925 15.7501H17.3193L12.8193 9.7501L8.31925 15.7501Z"
      fill={props.color ?? "white"}
    />
  </svg>
)

export const CaretDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.8193 17.25C12.7027 17.2508 12.5876 17.224 12.4833 17.1719C12.379 17.1198 12.2886 17.0437 12.2193 16.95L6.21925 8.95C6.13492 8.83802 6.08366 8.70465 6.07129 8.56501C6.05891 8.42537 6.08592 8.28506 6.14925 8.16C6.213 8.03712 6.3091 7.93399 6.42718 7.86173C6.54525 7.78947 6.68082 7.75084 6.81925 7.75H18.8193C18.9577 7.75084 19.0932 7.78947 19.2113 7.86173C19.3294 7.93399 19.4255 8.03712 19.4893 8.16C19.5526 8.28506 19.5796 8.42537 19.5672 8.56501C19.5548 8.70465 19.5036 8.83802 19.4193 8.95L13.4193 16.95C13.3499 17.0437 13.2595 17.1198 13.1552 17.1719C13.0509 17.224 12.9358 17.2508 12.8193 17.25ZM8.31925 9.25L12.8193 15.25L17.3193 9.25H8.31925Z"
      fill={props.color ?? "white"}
    />
  </svg>
)

export const CaretUpFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <polygon points="12.8193,7.75 19.3193,17.25 6.31925,17.25" fill={props.color ?? "white"} />
  </svg>
)

export const CaretDownFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <polygon points="6.31925,7.75 19.3193,7.75 12.8193,17.25" fill={props.color ?? "white"} />
  </svg>
)
